import { useState, useCallback } from 'react';
import { CartItemsContext } from 'store/cartItemsContext';

export const useCartItems = (nCartItems): CartItemsContext => {
  const [numCartItems, setNumCartItems] = useState<number>(nCartItems);

  const setUpdatedNumCartItems = useCallback((updatedCartItems: number): void => {
    setNumCartItems(updatedCartItems);
  }, []);

  return {
    numCartItems,
    setUpdatedNumCartItems,
  };
};
